// ゲーム機画面内の汎用確認ダイアログ（確定デザイン）。
// 削除・コピー・復活・公開切替・通報 など全確認に使う（accent / 確定音を可変）。
import { ReactNode, useEffect, useState } from "react";
import I18n from "common/i18n";
import Constants from "common/constant";
import { usePlaySound } from "common/utils";
import { InScreenModal } from "./ScreenModal";
import { BuilderModalPanel, BuilderModalAccent } from "./BuilderModalPanel";

// accent → 主ボタン(確定)の btn バリアント
const CONFIRM_BTN: Record<BuilderModalAccent, string> = {
  [BuilderModalAccent.GREEN]: "btn-primary",
  // 「やめる」が btn-blue なので、青にすると2つとも同じ見た目になって見分けられない
  [BuilderModalAccent.BLUE]: "btn-primary",
  [BuilderModalAccent.BROWN]: "btn-danger",
  [BuilderModalAccent.DANGER]: "btn-danger",
  [BuilderModalAccent.ORANGE]: "btn-secondary",
};

export const BuilderConfirmDialog = ({
  visible,
  title,
  message,
  close,
  handleConfirm,
  accent = BuilderModalAccent.DANGER,
  icon = "delete",
  confirmIcon = "delete_forever",
  confirmLabel,
  confirmSound = `${Constants.assetHost}/assets/sounds/delete.mp3`,
  extra,
}: {
  visible: boolean;
  title: string;
  message: string;
  close: () => void;
  handleConfirm: () => void;
  accent?: BuilderModalAccent;
  icon?: string;
  confirmIcon?: string;
  confirmLabel?: string;
  confirmSound?: string;
  /** 本文の下に差し込む中身（公開時の許可トグルなど） */
  extra?: ReactNode;
}) => {
  const playConfirm = usePlaySound(confirmSound);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (visible) setDisabled(false);
  }, [visible]);

  const handleClick = () => {
    if (disabled) return;
    setDisabled(true);
    playConfirm();
    handleConfirm();
  };

  return (
    <InScreenModal open={visible} onBackdropClose={close}>
      <BuilderModalPanel accent={accent} icon={icon} title={title} width={480}>
        <div className="flex-col-el items-start w-full">
          {message?.split("\n").map((line, index) => (
            <p key={index} className="type-text-left type-body text-textcolor-black mb-2">
              {line}
            </p>
          ))}
        </div>

        {extra}

        <div className="flex-row-el flex-center w-full gap-2 px-4 upsilon">
          <button type="button" onClick={close} className="type-inherit-font btn btn-blue">
            <div className="flex-row-center gap-1">
              <span className="material-symbols-outlined text-white type-md">close</span>
              <p className="type-text type-body text-white">{I18n.t("MSG_STOP_BTN")}</p>
            </div>
          </button>
          <button
            type="button"
            onClick={handleClick}
            className={`type-inherit-font btn ${CONFIRM_BTN[accent]}`}
          >
            <div className="flex-row-center gap-1">
              <span className="material-symbols-outlined text-white type-md">{confirmIcon}</span>
              <p className="type-text type-body text-white">
                {confirmLabel ?? I18n.t("MSG_DELETE_BTN")}
              </p>
            </div>
          </button>
        </div>
      </BuilderModalPanel>
    </InScreenModal>
  );
};
